import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
    Validator
} from 'vee-validate'

export default {
  name: 'forgotpassword',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      email: '',
      successmsg: '',
      errormsg: '',
      isLoading: false,
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

    forgotPassword(event) {
      this.successmsg = '';
      this.errormsg = '';
      this.isLoading = true;

      this.input = {
        email: this.email
      };

      axios({
        method: "POST",
        url: apiUrl.api_url + "forgotpassword",
        data: this.input,
        headers: {
          'Authorization': 'Bearer XYZ'
        }
        }).then((response) => {
          this.isLoading = false;
          /*--maintenance page call start--*/
          if(response && response.data.ReturnCode=='104')
          {
            this.$router.push("/maintenance");
          }
          /*--maintenance page call end--*/
          if(response.data.code==200){
            //this.$alertify.success(response.data.message);
            this.successmsg = response.data.message;
            event.target.reset();

          }else{
            //this.$alertify.error(response.data.error);
            this.errormsg = response.data.error;
              event.target.reset();
          }
        }).catch((httpException) => {
          //this.$alertify.success("Logging Failed");
          console.error('exception is:::::::::', httpException)
        })
    },

    resetForm() {
        this.email = '';
        this.errors.clear();
        this.$router.push('/login');
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.forgotPassword(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/forgotpassword/forgotpassword.component.js